import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { resetPassword } from '../../actions/authAction'
import { RESET_PASSWORD_RESET } from '../../constants/actionTypes'
import * as Yup from "yup";
import { useFormik } from 'formik';
import './style.css';
import logo from '../../assets/icons/MetaBrief_horizontal_RBG.jpg'

const ResetPassword = ({ history, match }) => {

    const dispatch = useDispatch()

    // const [id, setId] = useState('');
    // const [type, setType] = useState('');
    const [viewPassword , setViewPassword] = useState('password')
    useEffect(() => {
        // if (!localStorage.getItem('forgotPassword')) {
        //     history.push('/')
        // }
        // if (match.params) {
        //     setId(match.params.id);
        //     setType(match.params.type);
        // }
    }, [])

   
    const formik = useFormik({
		initialValues: {
			password: '',
			passwordConfirmation: '',
		},
		validationSchema: Yup.object({
            password: Yup.string()
			.max(12, 'Must be 12 characters or less')
			.min(6, 'Must be 6 characters or more')
			.required('Please Enter your password')
			.matches(
				/^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{6,12}$/,
				"Must contain 6 characters, one uppercase, one lowercase, one number and one special case character"
			),
            passwordConfirmation: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Passwords must match'),
		}),
		onSubmit: (value, { resetForm }) => {
			 const formData = {
                password: value.password,
                id: match.params.id,
                type: match.params.type,
             };
            // console.log(id);
             dispatch(resetPassword(formData, history))
             dispatch({ type: RESET_PASSWORD_RESET })
			 resetForm();
		},
	});
    const handleClick = (e) => {
        e.preventDefault();
        const passwordStatus = viewPassword === 'password' ? 'text' : 'password'
        console.log(passwordStatus);
        setViewPassword(passwordStatus);
    }
    return (
        <>
        <div id="wrapper" className="au th-main">
            <div className="container">
                <div className="row clearfix">
                    {/* <div className="col-12">
                        <nav className="navbar navbar-expand-lg">
                            <span className="navbar-brand" ><img src={logo} width="130" height="40" className="d-inline-block align-top mr-2" alt="" /></span>
                            <ul className="navbar-nav">
                                <li className="nav-item"><Link className="nav-link" to="/register">Register</Link></li>
                            </ul>
                        </nav>                    
                    </div> */}
                    <div className="col-md-4 mx-auto">
                        <div className="card custom_card border-radius-10">
                        <div className="header text-center pb-0">
                        <p className="lead"><span className="navbar-brand" ><img src={logo} width="110" height="auto" className="img-fluid mt-2" alt="" /></span></p>
                        <h4 className='login_text'><strong>Reset Password</strong></h4> 
                                
                            </div>
                            <div className="body">
                                <p>Please enter your new password below to receive instructions for resetting password.</p>
                                {/* {error && <h6 className='text-danger pt-1'>{error}</h6>} */}
                                <form className="form-auth-small" onSubmit={formik.handleSubmit}>
                                    <div className="form-group mb-3 relative_pos">
                                    <span className='text_icon_input'><i className="icon-lock"></i></span>
                                        <label className="label" htmlFor="password">New Password</label>
                                        <div className='pass-wrapper'>
                                            <input name="password" type={viewPassword} {...formik.getFieldProps('password')} className="form-control custom_form_new" placeholder="Password" required />
                                            <span className="password__show" onClick={handleClick}>{viewPassword === 'text' ? <i className='fa fa-eye eyeIcon'></i> : <i className='eyeIcon fa fa-eye-slash'></i>}</span>
                                        </div>
                                        {formik.touched.password && formik.errors.password ? (
                                            <div className="text-danger pt-1">{formik.errors.password}</div>
                                        ) : null}
                                    </div>
                                    <div className="form-group relative_pos mb-3">
                                    <span className='text_icon_input'><i className="icon-lock"></i></span>
                                        <label className="label" htmlFor="password">Confirm Password</label>
                                        <input type="password" {...formik.getFieldProps('passwordConfirmation')} className="form-control custom_form_new" placeholder="Password" required />
                                        {formik.touched.passwordConfirmation && formik.errors.passwordConfirmation ? (
                                            <div className="text-danger pt-1">{formik.errors.passwordConfirmation}</div>
                                        ) : null}
                                    </div>
                                    <button type="submit" className="btn button btn-lg btn-block" >RESET PASSWORD</button>
                                    <div className="bottom">
                                        <span className="helper-text">Know your password? <Link to="/login">Login</Link></span>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default ResetPassword
